
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Box-',
  data() {
    return {
      estilos: {
        background: '#FAF0CA'
      }
    }
  }
})
